import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/supplier/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const supplier = {
  get: apiPathFunc(pathBase),
} as const;
